import React from "react";
import { func, bool, string } from "prop-types";

import "./label-with-arrow.m.css";

const LabelWithArrow = ({ label, onClick, isOpen = false }) => (
  <div styleName="label-with-arrow" onClick={onClick}>
    <div styleName="label" className="en-label-with-arrow">
      {label}
    </div>
    {isOpen ? <i styleName="up" /> : <i styleName="down" />}
  </div>
);

LabelWithArrow.propTypes = {
  label: string.isRequired,
  onClick: func,
  isOpen: bool
};

export default LabelWithArrow;
